// Octotel packages
export const octotelPackages = [
  // FTTH Packages
  {
    ID: 2802774,
    Title: "Octotel 1000/200Mbps FTTH - Octotel By WonderNet",
    Price: 1539.00,
    "Download speed (kbps)": 1024000,
    "Upload speed (kbps)": 204800,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 2802780,
    Title: "Octotel 150/150Mbps FTTH - Octotel By WonderNet",
    Price: 939.00,
    "Download speed (kbps)": 153600,
    "Upload speed (kbps)": 153600,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 2802782,
    Title: "Octotel 300/200Mbps FTTH - Octotel By WonderNet",
    Price: 1109.00,
    "Download speed (kbps)": 307200,
    "Upload speed (kbps)": 204800,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 18988215,
    Title: "Octotel 500/200Mbps FTTH - Octotel By WonderNet",
    Price: 1199.00,
    "Download speed (kbps)": 512000,
    "Upload speed (kbps)": 204800,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 18989553,
    Title: "Octotel 55/25Mbps FTTH - Octotel By WonderNet",
    Price: 549.00,
    "Download speed (kbps)": 56320,
    "Upload speed (kbps)": 25600,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 22559896,
    Title: "Octotel 25/25Mbps FTTH - Octotel By WonderNet",
    Price: 499.00,
    "Download speed (kbps)": 25600,
    "Upload speed (kbps)": 25600,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 22559898,
    Title: "Octotel 100/100Mbps FTTH - Octotel By WonderNet",
    Price: 829.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  
  // FTTB Packages
  {
    ID: 22559823,
    Title: "Octotel 50/50Mbps FTTB - Octotel By WonderNet",
    Price: 1599.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 22559900,
    Title: "Octotel 5/5Mbps FTTB - Octotel By Wondernet",
    Price: 799.00,
    "Download speed (kbps)": 5120,
    "Upload speed (kbps)": 5120,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 22559901,
    Title: "Octotel 10/10Mbps FTTB - Octotel By Wondernet",
    Price: 1399.00,
    "Download speed (kbps)": 10240,
    "Upload speed (kbps)": 10240,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 22559902,
    Title: "Octotel 100/100Mbps FTTB - Octotel By Wondernet",
    Price: 1799.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 22559903,
    Title: "Octotel 200/200Mbps FTTB - Octotel By Wondernet",
    Price: 1999.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 22559904,
    Title: "Octotel 300/300Mbps FTTB - Octotel By Wondernet",
    Price: 2599.00,
    "Download speed (kbps)": 307200,
    "Upload speed (kbps)": 307200,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 22559905,
    Title: "Octotel 1000/500Mbps FTTB - Octotel By Wondernet",
    Price: 4899.00,
    "Download speed (kbps)": 1024000,
    "Upload speed (kbps)": 512000,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 23559005,
    Title: "Octotel 100/100Mbps FTTB - Octotel By WonderNet",
    Price: 1599.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 23559006,
    Title: "Octotel 200/200Mbps FTTB - Octotel By WonderNet",
    Price: 1999.00,
    "Download speed (kbps)": 204800,
    "Upload speed (kbps)": 204800,
    Supplier: "Octotel",
    ISP: "Wondernet"
  },
  {
    ID: 23559007,
    Title: "Octotel 500/500Mbps FTTB - Octotel By WonderNet",
    Price: 2599.00,
    "Download speed (kbps)": 512000,
    "Upload speed (kbps)": 512000,
    Supplier: "Octotel",
    ISP: "Wondernet"
  }
];